import React from 'react';
import { FaReact, FaNodeJs, FaPython, FaAws, FaDocker, FaFigma, FaDatabase } from 'react-icons/fa';
import { SiTypescript, SiNextdotjs, SiMongodb, SiFirebase, SiKotlin, SiSwift, SiTailwindcss, SiGraphql } from 'react-icons/si';

const TechStack = () => {
    const techItems = [
        { icon: <FaReact />, name: 'React' },
        { icon: <SiNextdotjs />, name: 'Next.js' },
        { icon: <FaNodeJs />, name: 'Node.js' },
        { icon: <SiTypescript />, name: 'TypeScript' },
        { icon: <FaPython />, name: 'Python' },
        { icon: <SiMongodb />, name: 'MongoDB' },
        { icon: <FaAws />, name: 'AWS' },
        { icon: <FaDocker />, name: 'Docker' },
        { icon: <SiKotlin />, name: 'Kotlin' },
        { icon: <SiSwift />, name: 'Swift' },
        { icon: <FaFigma />, name: 'Figma' },
        { icon: <SiTailwindcss />, name: 'Tailwind' },
        { icon: <SiFirebase />, name: 'Firebase' },
        { icon: <SiGraphql />, name: 'GraphQL' },
        { icon: <FaDatabase />, name: 'SQL' },
    ];

    return (
        <section className="tech-stack-section">
            <div className="container">
                <div className="text-center mb-5">
                    <p className="tech-heading-small text-center">POWERED BY MODERN TECH</p>
                    <h2 className="tech-heading text-center">Our Technology Stack</h2>
                </div>

                <div className="marquee-wrapper">
                    <div className="marquee-content">
                        {/* Duplicate the list to create seamless infinite scroll */}
                        {[...techItems, ...techItems].map((item, index) => (
                            <div className="tech-item" key={index}>
                                <div className="tech-icon">{item.icon}</div>
                                <span className="tech-name">{item.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style>{`
                .tech-stack-section {
                    background-color: #080014;
                    padding: 80px 0;
                    overflow: hidden;
                    position: relative;
                }

                .tech-heading-small {
                    color: #a04ff4;
                    font-size: 0.9rem;
                    letter-spacing: 2px;
                    font-weight: 700;
                    margin-bottom: 10px;
                    text-transform: uppercase;
                }

                .tech-heading {
                    color: #fff;
                    font-size: 2.5rem;
                    font-weight: 700;
                }

                .marquee-wrapper {
                    position: relative;
                    width: 100%;
                    overflow: hidden;
                    padding: 20px 0;
                    background: linear-gradient(90deg, #080014 0%, transparent 10%, transparent 90%, #080014 100%);
                }

                .marquee-content {
                    display: flex;
                    gap: 60px;
                    animation: scroll 30s linear infinite;
                    width: max-content;
                }

                .tech-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: #d0d0d0;
                    font-size: 1.5rem;
                    font-weight: 600;
                    opacity: 0.7;
                    transition: all 0.3s ease;
                    cursor: default;
                }

                .tech-item:hover {
                    opacity: 1;
                    color: #fff;
                    transform: scale(1.1);
                    text-shadow: 0 0 10px rgba(160, 79, 244, 0.5);
                }

                .tech-icon {
                    font-size: 2.2rem;
                    color: #a04ff4;
                }

                @keyframes scroll {
                    from { transform: translateX(0); }
                    to { transform: translateX(-50%); }
                }

                @media (max-width: 768px) {
                    .tech-heading { font-size: 2rem; }
                    .marquee-content { gap: 40px; }
                    .tech-item { font-size: 1.2rem; }
                    .tech-icon { font-size: 1.8rem; }
                }
            `}</style>
        </section>
    );
};

export default TechStack;
